import React from 'react'

import { MainHeader } from './MainHeader'
import { MobileHeader } from './MobileHeader'

type PropsType = {
  logoImage: string
  mobileLogoImage?: string
}

export const Header: React.FC<PropsType> = ({ logoImage, mobileLogoImage }) => (
  <>
    <MainHeader logoImage={logoImage} />
    <MobileHeader logoImage={mobileLogoImage ?? logoImage} />
  </>
)
